<onyx-section [heading]="`${I18N}.heading`">
  <div rightHeading class="heading f-muted">
    <onyx-icon name="tooltip-filled" [size]="16"></onyx-icon>

    <p>{{ `${I18N}.missingLicenseOrPermit` | translate }}</p>
  </div>

  <form [formGroup]="form()">
    <onyx-tabs
      data-testid="group-tabs"
      [formControl]="form().controls.group"
      [label]="`${I18N}.group`"
      [tabs]="countryGroupsTabs()"
      [fill]="true"
      [size]="32"
      width="100%"
    ></onyx-tabs>

    <onyx-dropdown
      data-testid="whitelist-dropdown"
      [formControl]="form().controls.whitelist"
      [label]="`${I18N}.whitelist`"
      [options]="options()"
      [size]="32"
      [multiple]="true"
      [search]="true"
    ></onyx-dropdown>
  </form>
</onyx-section>
